export default {
  meta: {
    title: '添加规划审批详情',
    parentPath: ['/expandstore/approver'],
    url: '/expandstore/approver',
    breadcrumbs: {
      path: ['/expandstore/approver'],
      name: ['审批工作台'],
    },
  },
};
